import { Grid, Typography } from '@mui/material';
import ActionsPopper from 'pages/selections/components/poppers/ActionsPopper';
import { OptionsCount } from 'pages/variants/common/options-count';
import { variantActionsPermissions } from 'pages/variants/permissions';
import { styles } from './styles';

interface IVariantItem {
  name: string;
  count: number;
  canEdit: boolean;
  canDelete: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

export const VariantItem = ({ name, count, canEdit, canDelete, onEdit, onDelete }: IVariantItem) => {
  const showActions = canEdit || canDelete;

  return (
    <Grid sx={styles.container}>
      <Grid sx={styles.content}>
        <Typography noWrap sx={styles.name}>
          {name}
        </Typography>
        <OptionsCount count={count} />
      </Grid>
      {showActions ? (
        <ActionsPopper
          permissions={variantActionsPermissions}
          isEditItem={canEdit}
          isDeleteItem={canDelete}
          handleEdit={onEdit}
          handleDelete={onDelete}
        />
      ) : null}
    </Grid>
  );
};
